import { fetchStaticJson } from '../../config/fetchStaticJson';
import { genderTypes } from '../../enums/genderTypes';
import { translateActions } from './translate-slice';

function translationFileUrl(lang) {
  const template =
    window.config?.translationFile ||
    `${(process.env.PUBLIC_URL || '').replace(/\/$/, '')}/translate/lang.json`;
  return template.replace('lang', lang);
}

function mergeTranslationTexts(res, { genderId, studentkita } = {}) {
  if (!res || typeof res !== 'object') {
    return {};
  }

  const hasGenderKeys = Object.keys(res).some((key) =>
    Object.values(genderTypes).includes(key)
  );
  if (!hasGenderKeys) {
    return res;
  }

  const genderText = res[genderTypes[genderId]] || {};
  const allText = res.all || {};
  const useDotted =
    studentkita &&
    window?.config?.dottedText?.includes(Number(studentkita)) &&
    !localStorage.getItem('getHighSchoolApp');
  const dottedText = useDotted
    ? { ...genderText.dotted, ...allText.dotted }
    : {};

  return { ...allText, ...genderText, ...dottedText };
}

export const initTexts = () => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const lang = state.translate.lang;
      if (!lang) return;

      const genderId =
        state.auth.userDetails?.genderId ?? state.auth.user?.genderId;
      const studentkita = state.auth.user?.studentkita;
      const res = await fetchStaticJson(translationFileUrl(lang));
      const myTexts = mergeTranslationTexts(res, { genderId, studentkita });
      dispatch(translateActions.initText({ texts: myTexts || {} }));
    } catch {
      // leave texts empty on failure
    }
  };
};

export const initLang = () => {
  return async (dispatch) => {
    try {
      let lang = localStorage.getItem('LANG');
      if (!lang) {
        lang = 'he';
        localStorage.setItem('LANG', lang);
      }
      const direction = 'rtl';
      document.documentElement.lang = lang;
      dispatch(translateActions.initLang({ lang, direction }));
    } catch {
      // ignore
    }
  };
};

export const changeLang = (lang) => {
  return async () => {
    try {
      localStorage.setItem('LANG', lang);
      window.location.reload();
    } catch {
      // ignore
    }
  };
};
